import React, { useEffect, useState } from "react";
import Nav from "../components/Nav/Nav";
import { LoadingOutlined } from "@ant-design/icons";
import { useAuth } from "../contexts/AuthContext";
import "../style/UserInformations.css";

function UserInformations() {
  const {
    currentUser,
    userProfile,
    userProfileLoading,
    getInformationsClient,
    saveInformationsClient,
  } = useAuth();

  const [phone, setPhone] = useState("");
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [promoOptOut, setPromoOptOut] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!currentUser?.uid) return;
    getInformationsClient();
    console.log(message)
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  useEffect(() => {
    if (!userProfile) return;

    setPhone(userProfile.phone || currentUser?.phoneNumber || "");
    setFirstName(userProfile.firstName || "");
    setEmail(userProfile.email || currentUser?.email || "");
    setAddress(userProfile.address || "");
    setPromoOptOut(Boolean(userProfile.promoOptOut));
  }, [userProfile, currentUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsSaving(true);
      setMessage("");

      await saveInformationsClient({
        firstName,
        email,
        address,
        promoOptOut,
      });

      setMessage("Enregistré.");
      setTimeout(() => {
        setMessage("");
      }, 3000);
    } catch (error) {
      console.log(error);
      setMessage("Une erreur est survenue.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="menu-wrapper">
      <div className="menu-container2">
        <div className="one-page">
          <Nav menu />

          <div className="main">
            <div className="orders-page">
              <div className="order-content">
                <div className="orders-header-inner">
                  <div className="title-back">
                    <h1 className="orders-page-title">Informations</h1>
                  </div>
                </div>
              </div>

              <div className="order-content infos-form-wrap">
                {userProfileLoading ? (
                  <div className="orders-loading">
                    <LoadingOutlined spin />
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="infos-form">
                    <input
                      className="auth-input imput-desable"
                      type="tel"
                      placeholder="Téléphone"
                      value={phone}
                      disabled
                    />

                    <input
                      className="auth-input"
                      type="text"
                      placeholder="Prénom"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />

                    <input
                      className="auth-input infos-input"
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />

                    <input
                      className="auth-input infos-input"
                      type="text"
                      placeholder="7 Rue de Paradis, 75010 Paris"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />

                    <label className="infos-checkbox-row">
                      <input
                        type="checkbox"
                        className="modal-opt-checkbox"
                        checked={promoOptOut}
                        onChange={(e) => setPromoOptOut(e.target.checked)}
                      />
                      <span>Je ne veux pas recevoir de promotions</span>
                    </label>

                    <div className="infos-bottom">
                      <div className="infos-divider" />

                      <button type="submit" className="modal-close-button infos-save-button">
                        {isSaving ?  <LoadingOutlined spin />: "Enregistrer"}
                      </button>

                      
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserInformations;